import { api } from '../index.js'

export default {
  namespaced: true,

  state: {
    filters: [],
    contactFilters: [],
    leadFilters: []
  },

  mutations: {
    updateFilters(state, [filters, contactFilters, leadFilters]) {
      state.filters = filters
      state.contactFilters = contactFilters
      state.leadFilters = leadFilters
    }
  },

  actions: {
    async fetchAll({ commit }) {
      let [filters] = await api.filters.all()
      let [contactFilters] = await api.filters.allContactFilters()
      let [leadFilters] = await api.filters.allLeadFilters()
      commit('updateFilters', [filters, contactFilters, leadFilters])
    }
  }
}
